import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AgrupamentoStringbox } from 'src/app/models/agrupamento-stringbox';
import { AgrupamentoStringboxCD } from 'src/app/models/agrupamento-stringbox-cd';
import { AgrupamentoStringboxItem } from 'src/app/models/agrupamento-stringbox-item';
import { Fornecedor } from 'src/app/models/fornecedor';
import { Produto } from 'src/app/models/produto';
import { AgrupamentoStringboxService } from 'src/app/services/agrupamento-stringbox.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { ProdutoService } from 'src/app/services/produto.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-cadastrar-agrupamento-stringbox-modal',
  templateUrl: './cadastrar-agrupamento-stringbox-modal.component.html',
  styleUrls: ['./cadastrar-agrupamento-stringbox-modal.component.scss']
})
export class CadastrarAgrupamentoStringboxModalComponent implements OnInit {

  idAgrupamento;
  idInversor;
  agrupamento: AgrupamentoStringbox = new AgrupamentoStringbox();
  stringboxes: Produto[] = [];
  fornecedores: Fornecedor[] = [];
  fornecedoresSelecionados: number[] = [];
  pCentroDistribuicao = false;


  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('agrupamentoForm', { static: true }) public agrupamentoForm: NgForm;

  constructor(public dialogRef: MatDialogRef<CadastrarAgrupamentoStringboxModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private agrupamentoStringboxService: AgrupamentoStringboxService,
    public dialog: MatDialog,
    private produtoService: ProdutoService,
    private fornecedorService: FornecedorService,
    private premissasService: PremissasService) {
    this.idAgrupamento = data.idAgrupamento;
    this.idInversor = data.idInversor;
  }

  async ngOnInit() {

    this.buscarStringboxes();

    await this.buscarPremissaCentroDeDistribuicao();

    if (this.pCentroDistribuicao) {
      this.buscarFornecedores();
    }

    if (this.idAgrupamento) {
      await this.buscarAgrupamento();
    } else {
      this.agrupamento.ativo = true;
    }

    if (this.agrupamento.itens === null || this.agrupamento.itens === undefined) {
      this.agrupamento.itens = [];
    }
  }

  async buscarPremissaCentroDeDistribuicao() {
    try {
      this.pCentroDistribuicao = (await this.premissasService.consultarCentroDeDistribuicao().toPromise()).valor;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  async buscarAgrupamento() {
    try {
      this.carregandoService.mostra('buscarAgrupamento');
      this.agrupamento = await this.agrupamentoStringboxService.consultarPorId(this.idAgrupamento).toPromise();

      if (this.pCentroDistribuicao) {
        this.fornecedoresSelecionados = this.agrupamento.cds.map(p => p.idCD);
      } else {
        this.fornecedoresSelecionados = [];
      }

    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarAgrupamento');
    }
  }

  async buscarStringboxes() {
    try {
      this.carregandoService.mostra('buscarStringboxes');
      this.stringboxes = await this.produtoService.buscarStringboxes().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarStringboxes');
    }
  }

  async buscarFornecedores() {
    try {
      this.carregandoService.mostra('buscarFornecedores');
      this.fornecedores = await this.fornecedorService.consultarFornecedores().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarFornecedores');
    }
  }

  adicionarStringbox() {
    const novo = new AgrupamentoStringboxItem();
    novo.qtd = 1;
    this.agrupamento.itens.push(novo);
  }

  excluirStringbox(stringbox: AgrupamentoStringboxItem) {
    this.agrupamento.itens.splice(this.agrupamento.itens.indexOf(stringbox), 1);
  }

  aumentarQtd(item: AgrupamentoStringboxItem) {
    item.qtd++;
  }

  diminuirQtd(item: AgrupamentoStringboxItem) {
    if (item.qtd > 1) {
      item.qtd--;
    }
  }

  async salvar() {

    if (!this.validar())
      return;

    try {
      this.carregandoService.mostra('salvar');

      this.agrupamento.cds = this.fornecedoresSelecionados.map(p => {
        const acd = new AgrupamentoStringboxCD();
        acd.idCD = p;
        return acd;
      });

      this.agrupamento.idInversor = this.idInversor;
      this.agrupamento.idMarca = [...new Set(this.agrupamento.itens.map(p => this.stringboxes.find(s => s.idProduto === p.idProduto).marca))][0];

      await this.agrupamentoStringboxService.salvar(this.agrupamento).toPromise();
      this.dialogRef.close(true);
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('salvar');
    }
  }

  fechar() {
    this.dialogRef.close();
  }

  validar() {
    return !(!this.agrupamentoForm.valid ||
      this.agrupamento.itens.length === 0 ||
      this.agrupamento.itens.some(p => p.idProduto === null || p.idProduto === undefined) ||
      this.agrupamento.itens.some(p => this.stringboxes.find(s => s.idProduto === p.idProduto).marca === 0
        || this.stringboxes.find(s => s.idProduto === p.idProduto).marca === null || this.stringboxes.find(s => s.idProduto === p.idProduto).marca === undefined) ||
      [...new Set(this.agrupamento.itens.map(p => this.stringboxes.find(s => s.idProduto === p.idProduto).marca))].length > 1);
  }

  selecionouStringbox(item: AgrupamentoStringboxItem) {

    if (item.idProduto === null || item.idProduto === undefined)
      return;

    const stringbox = this.stringboxes.find(s => s.idProduto === item.idProduto);

    if (stringbox.marca === null || stringbox.marca === undefined || stringbox.marca === 0) {
      swal({
        title: 'ATENÇÃO!!!',
        html: 'Stringbox sem marca!!',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).then(() => { item.idProduto = null; }).catch(swal.noop);

    } else if ([...new Set(this.agrupamento.itens.filter(p => p.idProduto !== null && p.idProduto !== undefined).map(p => this.stringboxes.find(s => s.idProduto === p.idProduto).marca))].length > 1) {
      swal({
        title: 'ATENÇÃO!!!',
        html: 'As stringboxes precisam ser da mesma marca!!',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).then(() => { item.idProduto = null; }).catch(swal.noop);
    } else if (this.agrupamento.itens.some(p => p !== item && p.idProduto === item.idProduto)) {
      swal({
        title: 'ATENÇÃO!!!',
        html: 'Essa stringbox já está sendo utilizada!!',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).then(() => { item.idProduto = null; }).catch(swal.noop);
    }
  }

}
